/**
 * @Author: wuyang
 * @Date: 2024/1/25
 * @Description: 全局单例 socket 实例
 */
import { BaseAbstractClass, IBaseAbstractClassProps } from '@/helper/base/BaseAbstractClass'
import { SOCKETIO_URL } from '@/constant'
import { SocketService } from '@/helper/services/socket/SocketService'
import { ISocketMessage } from '@/types/socket'
import io, { Socket } from 'socket.io-client'

export interface ISocketIOInstanceProps extends IBaseAbstractClassProps {}

export class SocketIOInstance extends BaseAbstractClass<ISocketIOInstanceProps> {
	static instance: SocketIOInstance
	private baseUrl = SOCKETIO_URL
	private socket: Socket | undefined
	// 子类 socket 的结果
	private socketServiceSet: Set<SocketService> = new Set()
	constructor(props: ISocketIOInstanceProps) {
		super(props)
		this.init(props)
	}

	protected init(props: ISocketIOInstanceProps) {
		super.init(props)
	}

	// 心跳检测



	// 增加子类 socket
	addSocketService(sk: SocketService) {
		this.socketServiceSet.add(sk)
	}
	// 删除子类 socket
	delSocketService(sk: SocketService) {
		this.socketServiceSet.delete(sk)
	}

	// 建立WebSocket连接
	webSocketConnect() {
		this.socket?.connect()
		console.log('SOCKET: call connect and current connection status is ', this.socket?.connected);
	}

	// 关闭WebSocket连接
	webSocketClose() {
		this.socket?.disconnect()
		console.log('SOCKET: call disconnect and current connection status is ', this.socket?.connected)
	}

	// 接收到数据
	webSocketOnMessage(res: string) {
		console.info('socket receive data')
		try {
			const data = JSON.parse(res) as ISocketMessage
			this.socketServiceSet.forEach((sk) => {
				sk.mitt.emit(data.pushType, data.message)
			})
		} catch (err) {
			console.error('SOCKET: failed to fetch data ', err)
		}
	}


	// 有登录状态时链接
	connect(userId: string) {
		const baseUrl = this.baseUrl
		// this.socket = io('ws://localhost:8080', {
    //   path:'/echo',
		// 	transports: ['websocket'],
    //   // autoConnect: false,
    //   // reconnection: false
		// })

    this.socket =  io(`${baseUrl}?userId=${userId}`,{
      transports:['websocket']
    })


		// 监听本次连接
		this.socket?.on('connect', () => {
			console.log('SOCKET: 连接成功！')
		})

		// 监听错误
		this.socket?.on('connect_error', (err) => {
			console.log('SOCKET: 连接失败, err:', err)
			// this.webSocketConnect()
		})

		// 监听重连
		this.socket?.on("reconnect", () => {
			console.log('SOCKET: listen for reconnect');
		});

		//监听断开
		this.socket?.on('disconnect', (reason: string, code: number) => {
			switch (reason) {
				case 'io client disconnect':
					// 该错误需要手动重连
					console.error('SOCKET: CODE: ', code, 'ERR: io client disconnect 客户端断开socket连接');
					this.webSocketConnect()
					break;
				case 'io server disconnect':
					// 该错误需要手动重连
					console.error('SOCKET: CODE: ', code, 'ERR: io server disconnect 服务器断开socket连接');
					this.webSocketConnect()
					break;
				default:
					console.error('SOCKET: CODE: ', code, ' ERR: ', reason);
					break;
			}
		})

		// 触发meaasage事件
		// this.socket?.emit('message', 'message', (data: string) => {
		// 	console.log('SOCKET: emit message, data:', data)
		// 	this.webSocketOnMessage(data)
		// })

		// 监听message事件
		this.socket?.on('message', (data: any) => {
			console.log('SOCKET: listen for message, data:', JSON.parse(data))
			this.webSocketOnMessage(data)
		})

		// this.socket?.emit('getUserRooms', 'getUserRooms数据', (data: string) => {
		// 	console.log('sokcer---getUserRooms', data)
		// })
	}

	// 退出登录时断开链接
	disConnect() {
		// this.socketServiceSet.clear() // 退出重新登录
		this.webSocketClose()
	}
}
